/**
 *  the idea here is, if flag is Active from UI only then the backend flag will be entertained.
 *  otherwise backend flag won't control anything.
 *
 *  Also, we can keep some other key to mark if the flag is retired. While retiring a flag, it
 *  is the responsibility of developer to remove all un-reachable code and files from the project.
 *
 *  A feature flag utility is present which works on following logic ( true means new functionality hidden under flag should be visible)
 *  - if flag is not present in following object, return false always.
 *  - else if flag is Retired, it will always return true ( this is for cases where impossible deadlines are forced on devs and there is no time for actually retiring the flag).
 *  - else if it is active return true
 *  - else return false.
 *
 *  PS: Devs please ask for extra time when marking a flag as retired.
 * */
export const FEATURE_FLAGS = {
  MESH_RECOMMENDATION: {
    key: 'MESH_RECOMMENDATION',
    isActive: true,
    isRetired: true,
  },
  OKR_VIEW: {
    key: 'OKR_VIEW',
    isActive: true,
    isRetired: true,
  },
  ONE_ON_ONE_V2: {
    key: 'ONE_ON_ONE_V2',
    isActive: true,
    isRetired: true,
  },
  ENABLE_AI_REVIEW_COMMENTS: {
    key: 'ENABLE_AI_REVIEW_COMMENTS',
    isActive: true,
    isRetired: false,
  },
  ENABLE_AI_REVIEW_MANAGER_SUMMARY: {
    key: 'ENABLE_AI_REVIEW_MANAGER_SUMMARY',
    isActive: true,
    isRetired: false,
  },
  ONE_ON_ONE_V2_EVENT_AGENDA: {
    key: 'ONE_ON_ONE_V2_EVENT_AGENDA',
    isActive: true,
    isRetired: false,
  },
  GOAL_GEN_AI: {
    key: 'GOAL_GEN_AI',
    isActive: true,
    isRetired: false,
  },
  ONE_ON_ONE_TRANSCRIPTION: {
    key: 'ONE_ON_ONE_TRANSCRIPTION',
    isActive: true,
    isRetired: false,
  },
  ONE_ON_ONE_V2_ML: {
    key: 'ONE_ON_ONE_V2_ML',
    isActive: true,
    isRetired: false,
  },
  VISIER_ANALYTICS: {
    key: 'VISIER_ANALYTICS',
    isActive: true,
    isRetired: false,
  },
  CF_GEN_AI: {
    key: 'CF_GEN_AI',
    isActive: true,
    isRetired: false,
  },
  // deprecated and retired flag value from LD
  NEW_NAV: {
    key: 'NEW_NAV',
    isActive: true,
    isRetired: true,
  },
  DENY_PUBLIC_CF_VISIBILITY: {
    key: 'DENY_PUBLIC_CF_VISIBILITY',
    isActive: true,
    isRetired: false,
  },
  RELEASE_NEW_NAV_STATIC_DATA_FEATURES: {
    key: 'release-new-nav-static-data-features',
    isActive: true,
    isRetired: false,
  },
  RELEASE_SANDBOX_STATIC_DATA_FEATURES: {
    key: 'release-sandbox-new-nav-static-data-features',
    isActive: true,
    isRetired: false,
  },
  RELEASE_VISIER_REPORTS: {
    key: 'release-visier-reports',
    isActive: true,
    isRetired: false,
  },
  RELEASE_REVIEWS_OVERVIEW_BOX_GRID: {
    key: 'release-reviews-overview-box-grid',
    isActive: true,
    isRetired: false,
  },
  OVERVIEW_EXPLANATIONS: {
    key: 'OVERVIEW_EXPLANATIONS',
    isActive: true,
    isRetired: false,
  },
  OVERVIEW_REVIEWS_EXPLANATIONS: {
    key: 'release-overview-reviews-explanation',
    isActive: true,
    isRetired: false,
  },
  LIFECYCLE_INSIGHTS: {
    key: 'release-lifecycle-insights',
    isActive: true,
    isRetired: false,
  },
  REVIEW_ACTION_PLAN: {
    key: 'release-review-plan-of-action',
    isActive: true,
    isRetired: false,
  },
  SAME_DAY_REVIEW_LAUNCH_EMAIL: {
    key: 'same-day-review-launch-email',
    isActive: true,
    isRetired: false,
  },
  EMPLOYEE_PERSONA_REVIEW_REPORT: {
    key: 'release-review-report-employee-persona',
    isActive: true,
    isRetired: false,
  },
  DEMO_AI_CALIBRATION: {
    key: 'demo-ai-calibration',
    isActive: true,
    isRetired: false,
  },
  RELEASE_SETTINGS_PAGE_REVAMP: {
    key: 'release-settings-page-revamp',
    isActive: true,
    isRetired: true,
  },
  DEMO_PREDICTIVE_SCORE_OFF_CYCLE: {
    key: 'demo-predictive-score-offcycle',
    isActive: true,
    isRetired: false,
  },
  RELEASE_FEEDBACK_INCLUSION: {
    key: 'release-feedback-inclusion',
    isActive: true,
    isRetired: false,
  },
  RELEASE_REVIEW_INCLUSION: {
    key: 'release-review-inclusion',
    isActive: true,
    isRetired: false,
  },
  DEMO_REVIEW_CREATION_TRIGGERED_REVIEWS: {
    key: 'demo-review-creation-triggered-reviews',
    isActive: true,
    isRetired: false,
  },
  RELEASE_REVIEW_MOBILE_FEEDBACK_TYPE: {
    key: 'release-review-mobile-feedback-type',
    isActive: true,
    isRetired: false,
  },
  // left over from in development feature, the flag is not added to LD yet
  ENABLE_SETTINGS_REVAMP_EMPLOYEE_ROSTER: {
    key: 'enable-settings-revamp-employee-roster',
    isActive: true,
    isRetired: false,
  },
  ENABLE_REVIEW_VIEW_BASED_FILTER: {
    key: 'enable-review-view-based-filter',
    isActive: true,
    isRetired: false,
  },
  HIDE_DEMO_ONE_ON_ONE_SECTIONS: {
    key: 'hide-demo-one-on-one-sections',
    isActive: true,
    isRetired: false,
  },
  ENABLE_COMPANY_SUPPORT: {
    key: 'enable-company-support',
    isActive: true,
    isRetired: false,
  },
  ENABLE_CALIBRATION_PRIVATE_COMMENTS: {
    key: 'enable-calibration-private-comments',
    isActive: true,
    isRetired: false,
  },
  ENABLE_REVIEW_REPORTS: {
    key: 'enable-review-reports',
    isActive: true,
    isRetired: false,
  },
  SHOW_EXTERNAL_EMPLOYEE_ID: {
    key: 'show-external-employee-id',
    isActive: true,
    isRetired: false,
  },
  ENABLE_SURVEY_PRESET_RECURRENCE: {
    key: 'enable-survey-preset-recurrence',
    isActive: true,
    isRetired: false,
  },
  ENABLE_GOAL_DATA_REPORTS_EXPORT: {
    key: 'enable-goal-data-reports-export',
    isActive: true,
    isRetired: false,
  },
  ENABLE_SIMPLIFIED_REVIEW_CREATION: {
    key: 'enable-simplified-review-creation',
    isActive: true,
    isRetired: false,
  },
  ENABLE_ESIGN_REVIEW_REPORT: {
    key: 'enable-e-sign-review-report',
    isActive: true,
    isRetired: false,
  },
  ENABLE_MANAGER_ESIGN_REVIEW_REPORT: {
    key: 'enable-manager-e-sign-review-report',
    isActive: true,
    isRetired: false,
  },
  ENABLE_COMPENSATION_MODULE: {
    key: 'enable-compensation-module',
    isActive: true,
    isRetired: false,
  },
  DISCIPLINARY_ACTION_GEN_AI: {
    key: 'disciplinary_action_gen_ai',
    isActive: true,
    isRetired: false,
  },
  ATTACHMENTS: {
    key: 'attachments',
    isActive: true,
    isRetired: false,
  },
  ENABLE_STATIC_DATA_COMPENSATION: {
    key: 'enable-static-data-compensation',
    isActive: true,
    isRetired: false,
  },
  ENABLE_SIMPLIFIED_REVIEW_DEMO_PRESETS: {
    key: 'enable-simplified-review-demo-presets',
    isActive: true,
    isRetired: false,
  },
  ENABLE_MOCK_DEMO_POINTS_MODULE: {
    key: 'enable-mock-demo-points-module',
    isActive: true,
    isRetired: false,
  },
  ENABLE_STATIC_REWARDS_MODULE: {
    key: 'enable-static-rewards-module',
    isActive: true,
    isRetired: false,
  },
  ENABLE_SHOW_DYNAMIC_COMPENSATION_BUDGET: {
    key: 'enable-show-dynamic-compensation-budget',
    isActive: true,
    isRetired: false,
  },
  ENABLE_PROBATION_CHECKIN_REVIEW: {
    key: 'enable-probation-checkin-review',
    isActive: true,
    isRetired: false,
  },
  ENABLE_SHOW_COMPENSATION_ANOMALIES: {
    key: 'enable-show-compensation-anomalies',
    isActive: true,
    isRetired: false,
  },
  ENABLE_SHOW_FUNCTION_ROLE_SPECIFIC_COMPETENCIES: {
    key: 'enable-show-function-role-specific-competencies',
    isActive: true,
    isRetired: false,
  },
  ENABLE_SHOW_ASSIGN_FINAL_REVIEWER: {
    key: 'enable-show-assign-final-reviewer',
    isActive: true,
    isRetired: false,
  },
  ENABLE_UPLOAD_DOCUMENTS_TO_DOCUMENT_CENTER: {
    key: 'enable-upload-documents-to-document-center',
    isActive: true,
    isRetired: false,
  },
  ENABLE_FINAL_REVIEWER_NOMENCLATURE: {
    key: 'enable-final-reviewer-nomenclature',
    isActive: true,
    isRetired: false,
  },
  ENABLE_REVIEWS_GOAL_WEIGHTAGE_REPORT: {
    key: 'enable-reviews-goal-weightage-report',
    isActive: true,
    isRetired: false,
  },
  ENABLE_COMPENSATION_BONUS: {
    key: 'enable-compensation-bonus',
    isActive: true,
    isRetired: false,
  },
  USE_LEGACY_REVIEW_REOPEN_FLOW: {
    key: 'use-legacy-review-reopen-flow',
    isActive: true,
    isRetired: false,
  },
  ENABLE_NEW_SURVEY_REPORTS: {
    key: 'enable-new-survey-reports',
    isActive: true,
    isRetired: false,
  },
  ENABLE_COMPENSATION_LETTER_DOWNLOAD: {
    key: 'enable-compensation-letter-download',
    isActive: true,
    isRetired: false,
  },
  ENABLE_COMPENSATION_RATE_BULK_UPLOAD: {
    key: 'enable-compensation-rate-bulk-upload',
    isActive: true,
    isRetired: false,
  },
  ENABLE_GIFTOGRAM_CATALOG: {
    key: 'enable-giftogram-catalog',
    isActive: true,
    isRetired: false,
  },
  ENABLE_REVIEW_SURVEY_MEMBERS_MODIFICATION: {
    key: 'enable-review-survey-members-modification',
    isActive: true,
    isRetired: false,
  },
  ENABLE_COMPENSATION_STAKEHOLDER_BULK_UPLOAD: {
    key: 'enable-compensation-stakeholder-bulk-upload',
    isActive: true,
    isRetired: false,
  },
  ENABLE_COMPENSATION_LETTER_PREVIEW: {
    key: 'enable-compensation-letter-preview',
    isActive: true,
    isRetired: false,
  },
  ENABLE_JOURNAL_TEMPLATE_BUILDER: {
    key: 'enable-journal-template-builder',
    isActive: true,
    isRetired: false,
  },
};
